import BaseValue, { SetPropertyActionValue } from './BaseValue'

export default class NowValue extends BaseValue {
  declare type: SetPropertyActionValue.Now
}
